import { render, staticRenderFns } from "./SpecialTransaction.vue?vue&type=template&id=63d82913&scoped=true"
import script from "./SpecialTransaction.vue?vue&type=script&lang=js"
export * from "./SpecialTransaction.vue?vue&type=script&lang=js"
import style0 from "./SpecialTransaction.vue?vue&type=style&index=0&id=63d82913&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d82913",
  null
  
)

export default component.exports